
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../store/httpClient";
import moment from "moment";
import { CreditNoteDto } from "@/dtos/creditNoteDto";
import { InvoiceManagementDto } from "@/dtos/invoiceManagementDto";
import { InvoiceSearchRequestDto } from "@/dtos/invoiceSearchRequestDto";
import { ErpInvoiceState } from "@/dtos/erpInvoiceState";

@Component
export default class CreateCreditNoteDialog extends Vue {
	@Prop()
	private customerId!: number;
	@Prop({ default: null })
	private orderId!: number | null;

	private open: boolean = true;
	private saving: boolean = false;
	private amount: number = 0;
	private note: string = "";
	private offsetWithOpenInvoices: boolean = false;
	private loadingInvoices: boolean = false;
	private openInvoices: InvoiceManagementDto[] = [];
	private selectedInvoiceId: number | null = null;

	private get canSave() {
		if (this.saving || this.amount <= 0) {
			return false;
		}
		// Wenn mit einer Rechnung verrechnet werden soll, muss eine ausgewählt sein.
		if (this.offsetWithOpenInvoices && !this.selectedInvoiceId) {
			return false;
		}
		return true;
	}

	private async onOffsetChanged(value: boolean) {
		this.selectedInvoiceId = null;
		if (value) {
			await this.loadOpenInvoices();
		}
	}

	private async loadOpenInvoices() {
		try {
			this.loadingInvoices = true;
			const request = new InvoiceSearchRequestDto();
			request.customerNumber = this.customerId.toString();
			request.states = [ErpInvoiceState.Gueltig, ErpInvoiceState.Unvollstaendig];
			// Ohne ein zukünftiges Fälligkeitsdatum werden keine Rechnungen zurückgegeben.
			request.dueUntil = moment().add(3, "months").toDate();
			const response = await httpClient().post("Invoice/GetInvoices?from=0&to=0", request);
			this.openInvoices = response.data;
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Laden der offenen Rechnungen.");
		} finally {
			this.loadingInvoices = false;
		}
	}

	private async save() {
		try {
			this.saving = true;
			const creditNote = new CreditNoteDto();
			creditNote.amount = this.amount;
			creditNote.reason = this.note;
			creditNote.customerId = this.customerId;
			creditNote.createdFromCustomerOrderId = this.orderId;
			creditNote.invoiceId = this.offsetWithOpenInvoices ? this.selectedInvoiceId : null;
			await httpClient().post("CreditNote/CreateCreditNote", creditNote);
			this.$store.commit("setSnackbarText", "Gutschrift wurde erfolgreich erstellt.");
			this.$emit("cancel", true);
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Erstellen der Gutschrift.");
		} finally {
			this.saving = false;
		}
	}

	private formatDate(date: Date) {
		return moment(date).format("DD.MM.YYYY");
	}
}
